export default __webpack_public_path__ + "static/media/news79.728cbd92.jpg";